import actionTypes from "../actionTypes";
import IAction from "../../types/IAction";

interface State {
  quantity: string;
  message: string;
  showQuantity: boolean;
  refresh: boolean;
  showViewsparkButton: boolean;
  showMessenger: boolean;
}

const initialState: State = {
  quantity: "",
  message: "",
  showQuantity: false,
  refresh: false,
  showViewsparkButton: true,
  showMessenger: true,
};

export default function commonReducer(
  state: State = initialState,
  action: IAction
): State {
  switch (action.type) {
    case actionTypes.CHANGE_SELECTED_ITEMS: {
      return {
        ...state,
        quantity: action.meta.quantity,
        message: action.meta.message,
        showQuantity: true,
      };
    }

    case actionTypes.HIDE_SELECTED_ITEMS: {
      return {
        ...state,
        quantity: null,
        message: null,
        showQuantity: false,
      };
    }

    case actionTypes.REFRESH_DASHBOARD: {
      return {
        ...state,
        refresh: !state.refresh,
      };
    }

    case actionTypes.TOGGLE_VIEWSPARK_BUTTON: {
      return {
        ...state,
        showViewsparkButton: action.meta.showViewsparkButton,
      };
    }

    case actionTypes.MESSENGER_OPTION: {
      return {
        ...state,
        showMessenger: action.payload,
      };
    }

    default: {
      return state;
    }
  }
}

export { initialState };
